import React, { useEffect, useState } from "react";
import { translate } from "../../../base/i18n";
import { connect as reactReduxConnect } from "../../../base/redux";
import Gridview from "./Gridview";
import HorizontalTiledView from "./HorizontalTiledView";
import VerticalTiledView from "./VerticalTiledView";
import FullView from "./FullView";
import { useSelector } from "react-redux";
import ConferenceTimer from "../../../conference/components/ConferenceTimer";
import { getConferenceNameForTitle } from "../../../base/conference";
import { SendCommandOnce } from "./actions";
import { setTileView } from "../../../video-layout";

const MeetInterface = ({
    topic,
    _participants,
    setView,
    viewLayout,
    isMaximize,
    setMaximize,
    _tracks,
    _tileViewEnabled,
    _chatOpen,
    _screensharing,
    fireGroupParticipants,
    _meetDetail,
    _roomName,
    additional_moderator,
    is_owner,
}) => {
    const { get_full_screen_userid } = useSelector(
        (state) => state["features/nxatel"]
    );

    let additionalModerator =
        additional_moderator &&
        additional_moderator.includes(APP.conference.getMyUserId())
            ? true
            : false;

    const [_EditMeetingTopic, setEditMeetingTopic] = useState(false);
    const [meetingName, setMeetingName] = useState(topic);

    useEffect(() => {
        if (get_full_screen_userid) {
            TileViewHandler("vertical");
        }
    }, [get_full_screen_userid]);

    const maximizeFullScreen = () => {
        setMaximize(true);
        var elem = document.getElementById("react");
        /* When the openFullscreen() function is executed, open the video in fullscreen.
            Note that we must include prefixes for different browsers, as they don't support the requestFullscreen method yet */
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
            /* Safari */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            /* IE11 */
            elem.msRequestFullscreen();
        }
    };

    const minimizeFullScreen = () => {
        setMaximize(false);
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            /* IE11 */
            document.msExitFullscreen();
        }
    };

    const SaveMeetingTopic = () => {
        let title = meetingName ? meetingName : topic;
        SendCommandOnce(
            "update-meeting-title",
            JSON.stringify({
                topic: title,
                _roomName,
                _meetDetail,
            })
        );
        setEditMeetingTopic(false);
    };

    const TileViewHandler = (type) => {
        setView(type);
        APP.store.dispatch(setTileView(true));
    };

    return (
        <>
            <div className="top-bar-tools">
                <div className="tools-logo">
                    <a href={void 0} className="navbar-brand">
                        <img
                            src="public/assets/images/logo-meet-new.svg"
                            alt="1"
                        />
                    </a>
                </div>
                <div className="top-tools-icons-div">
                    <p className="d-flex align-items-center edit-meeting-with-timer">
                        <span className="d-flex align-items-center ">
                            {is_owner || additionalModerator ? (
                                <>
                                    {_EditMeetingTopic && (
                                        <>
                                            <div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="meetingName"
                                                    value={meetingName}
                                                    onChange={(e) =>
                                                        setMeetingName(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                            <a href={void 0}>
                                                <i
                                                    className="fa fa-check"
                                                    onClick={SaveMeetingTopic}
                                                ></i>
                                            </a>
                                        </>
                                    )}
                                    {!_EditMeetingTopic && (
                                        <>
                                            {topic}
                                            <a href={void 0}>
                                                <i
                                                    className="fas fa-edit"
                                                    onClick={() =>
                                                        setEditMeetingTopic(
                                                            true
                                                        )
                                                    }
                                                ></i>
                                            </a>
                                        </>
                                    )}
                                </>
                            ) : (
                                <>{topic}</>
                            )}
                        </span>
                        <ConferenceTimer />
                    </p>
                    <a
                        href={void 0}
                        className="participant-ico"
                        onClick={() => $("#InviteModal").modal("show")}
                    >
                        <img
                            src="public/assets/images/participant-meet.svg"
                            alt="1"
                        />
                        <span>{_participants?.length}</span>
                    </a>
                    {!isMaximize && (
                        <li className="nav-item gird-drop dropup">
                            <a
                                href={void 0}
                                className="nav-link"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <img
                                    src="public/assets/images/grid-view-meet.svg"
                                    alt="view"
                                />
                            </a>
                            <div className="dropdown-menu">
                                <a
                                    className={`dropdown-item ${
                                        viewLayout === "grid" ? "active" : ""
                                    }`}
                                    href={void 0}
                                    onClick={() => TileViewHandler("grid")}
                                >
                                    Grid View
                                </a>
                                <a
                                    className={`dropdown-item ${
                                        viewLayout === "horizontal"
                                            ? "active"
                                            : ""
                                    }`}
                                    href={void 0}
                                    onClick={() =>
                                        TileViewHandler("horizontal")
                                    }
                                >
                                    Horizontal Tiled
                                </a>
                                <a
                                    className={`dropdown-item ${
                                        viewLayout === "vertical"
                                            ? "active"
                                            : ""
                                    }`}
                                    href={void 0}
                                    onClick={() => TileViewHandler("vertical")}
                                >
                                    Vertical Tiled
                                </a>
                            </div>
                        </li>
                    )}
                    {!isMaximize && (
                        <a
                            href={void 0}
                            className="expand-ico"
                            onClick={maximizeFullScreen}
                        >
                            <img
                                src="public/assets/images/expand-ico.svg"
                                alt="1"
                            />
                        </a>
                    )}

                    {isMaximize && (
                        <a
                            href={void 0}
                            className="expand-ico"
                            onClick={minimizeFullScreen}
                        >
                            <img
                                src="public/assets/images/minimize.svg"
                                alt="1"
                            />
                        </a>
                    )}
                </div>
            </div>
            {isMaximize && (
                <FullView
                    _screensharing={_screensharing}
                    _participants={_participants}
                    _tracks={_tracks}
                    _chatOpen={_chatOpen}
                    _tileViewEnabled={_tileViewEnabled}
                    screenSharedUserID={get_full_screen_userid}
                    fireGroupParticipants={fireGroupParticipants}
                />
            )}

            {viewLayout === "grid" && !isMaximize && (
                <Gridview
                    _screensharing={_screensharing}
                    _participants={_participants}
                    _tracks={_tracks}
                    _chatOpen={_chatOpen}
                    _tileViewEnabled={_tileViewEnabled}
                    fireGroupParticipants={fireGroupParticipants}
                />
            )}

            {viewLayout === "horizontal" && !isMaximize && (
                <HorizontalTiledView
                    _screensharing={_screensharing}
                    _participants={_participants}
                    _tracks={_tracks}
                    _chatOpen={_chatOpen}
                    _tileViewEnabled={_tileViewEnabled}
                    screenSharedUserID={get_full_screen_userid}
                    fireGroupParticipants={fireGroupParticipants}
                />
            )}

            {viewLayout === "vertical" && !isMaximize && (
                <VerticalTiledView
                    _screensharing={_screensharing}
                    _participants={_participants}
                    _tracks={_tracks}
                    _chatOpen={_chatOpen}
                    _tileViewEnabled={_tileViewEnabled}
                    screenSharedUserID={get_full_screen_userid}
                    fireGroupParticipants={fireGroupParticipants}
                />
            )}
        </>
    );
};

function _mapStateToProps(state) {
    const { meeting_details: _meetDetail } = state["features/nxatel_meet"];
    return {
        _roomName: getConferenceNameForTitle(state),
        _meetDetail,
        additional_moderator: state["features/nxatel"].additional_moderator,
    };
}

export default reactReduxConnect(_mapStateToProps)(translate(MeetInterface));
